module.exports = __webpack_public_path__ + "img/consult_info2.da531e50.png";